import { identifyForMonitoring } from '@/analytics/monitoring'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import './filters'
import VTooltip from 'v-tooltip'
import VueLazyload from 'vue-lazyload'
import VueInputAutowidth from 'vue-input-autowidth'
import VueMeta from 'vue-meta'
import DatePicker from 'vuejs-datepicker'
import AccessControl from '@/utilities/acl-directive'
import { trackingDirective } from '@/utilities/v-track-directive'
import api from '@/api'
import { getAuthToken } from '@/utilities/auth-token'
import { Session } from '@shared/types/graphql'
import { getUserInfo } from '@/analytics/ClientAnalyticsProvider'

Vue.use(VueLazyload)
Vue.use(VTooltip)
Vue.use(VueInputAutowidth)
Vue.use(VueMeta)
Vue.use(DatePicker)
Vue.directive('acl', AccessControl)
Vue.directive('track', trackingDirective)

Vue.config.productionTip = false

async function loadBootData () {
  const authToken = getAuthToken()
  if (authToken) {
    let session: Session | undefined | null

    try {
      session = await api.getSession()
    } catch (err) {
      console.error('Error getting session:', err)
      const path = window.location.pathname + window.location.search + window.location.hash
      router.push({ name: 'login', params: { continue: path } })
    }

    if (session) {
      store.dispatch.setSession(session)
      const userInfo = getUserInfo()
      if (userInfo) {
        identifyForMonitoring(userInfo)
      }
    }
  }

  new Vue({
    router,
    store: store.original,
    render: (h:Function) => h(App)
  }).$mount('#app')
}

loadBootData()
